import dayjs from 'dayjs';
import { Pagination, Table } from 'flowbite-react';

import type { CustomerFeedback } from 'src/api/models';
import { LoadingSpinner } from 'src/components/loading-spinner';

export interface FeedbackTableProps {
  isLoading: boolean;
  feedbacks: CustomerFeedback[];
  currentPage: number;
  setPage: (page: number) => void;
  totalPages: number;
}

export function FeedbackTable({
  isLoading,
  feedbacks,
  currentPage,
  setPage,
  totalPages,
}: FeedbackTableProps) {
  return (
    <>
      <div className='flex grow flex-col gap-1'>
        {isLoading && <LoadingSpinner />}
        {isLoading || (
          <Table striped>
            <Table.Body className='divide-y'>
              {feedbacks.map((f) => (
                <Table.Row key={`${f.id}`}>
                  <Table.Cell>
                    <div className='format format-red gap-1 text-sm'>
                      <p className='text-gray-700'>{f.text}</p>
                      <p>
                        By{' '}
                        <span className='font-medium text-gray-700'>
                          {f.email ?? f.phone_number}
                        </span>{' '}
                        - <span className='text-gray-400'>{dayjs(f.created_at).fromNow()}</span>
                      </p>
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </div>
      <div>
        <Pagination
          currentPage={currentPage}
          onPageChange={setPage}
          totalPages={totalPages}
        ></Pagination>
      </div>
    </>
  );
}
